import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddressComponent } from './address.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { RippleModule } from 'primeng/ripple';
import { SelectModule } from '../select/select.module';
import { InputNumberModule } from 'primeng/inputnumber';
import { DividerModule } from 'primeng/divider';
import { FormDirectivesModule } from '../../directives/form-directives.module';
import { PipeModule } from 'src/app/shared/pipe.module';

@NgModule({
  declarations: [AddressComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ButtonModule,
    RippleModule,
    DividerModule,
    InputTextModule,
    SelectModule,
    InputNumberModule,
    FormDirectivesModule,
    PipeModule,
  ],
  exports: [AddressComponent],
})
export class AddressModule {}
